import { ChoiceOption } from 'ui/types'

export const getOptionsQaAttrs = (option: ChoiceOption, optionDataQa?: string): string | undefined =>
  optionDataQa ? `${optionDataQa} - ${option.label}` : undefined
